<template>
    <div class="container-fluid w-100 h-100" style="overflow-x: hidden">
        <navbar :title="$t('contract_diary.title')" class="mb-1"/>
        <div class="col-sm-12 transparent-bg mt-2" style="overflow: hidden">
                <!-- Tabs Navigation -->
                <ul class="nav nav-tabs routa-tabs">
                    <li class="nav-item">
                        <button class="routa-tab" :class="{ active: tabIndex === 0 }" @click="tabIndex = 0">
                            {{ $t('contract_diary.new') }}
                        </button>
                             </li>
                    <li class="nav-item" v-if="isObserver">
                        <button class="routa-tab" :class="{ active: tabIndex === 1 }" @click="tabIndex = 1">
                            {{ $t('contract_diary.site_report') }}
                        </button>
                    </li>
                </ul>

                <!-- Tab Content -->
                <div class="tab-content routa-tab-content">
                    <!-- Tab 1: New Contract Diary -->
                    <div class="tab-pane fade" :class="{ show: tabIndex === 0, active: tabIndex === 0 }"  style="min-height: 75vh">
                        <contract-diaries-view :pre-selected-contract="preSelectedContract" :user="user" />
                    </div>

                <!-- Tab 2: Contract report diary -->
                <div class="tab-pane fade" :class="{ show: tabIndex === 1, active: tabIndex === 1 }"  style="min-height: 75vh">
                    <contract-weekly-diary-report />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {timeUtils} from "@/components/mixins/TimeUtils";
import {restApi} from "@/components/mixins/RestApiMixin";
import {workManagementHelper} from '@/components/mixins/WorkManagementMixin'
import {inject} from "vue";
import Navbar from "@/components/utils/Navbar";
import ContractWeeklyDiaryReport from "@/components/contractreport/ContractWeeklyDiaryReport.vue";
import ContractDiariesView from "./ContractDiariesView.vue";

export default {
    name: "contract-diaries",
    components: {
        ContractDiariesView,
        ContractWeeklyDiaryReport,
        SiteReport: ContractWeeklyDiaryReport, Navbar},
    mixins: [timeUtils, restApi, workManagementHelper],
    props: {
        isObserver: {
            type: Boolean,
            default: false
        },
        isMapViewer: {
            type: Boolean,
            default: false
        },
        preSelectedContract: {
            type: Object,
            default: null
        },
        user: {
            type: Object,
            default: null
        }
    },
    setup() {
        // Inject parents alerter
        const showAlert = inject('showAlert');
        return { showAlert };
    },
    data: function () {
        return {
            lastSearchedParams: null,
            results: [],
            loading: false,
            tabIndex: 0,
            contract: null,
            date: null,
        }
    },
    methods: {
        setContract(contract) {
            this.contract = contract
        },

        setDate(date) {
            this.date = new Date(date)
        },

        fetchDiaries: function (params) {
            this.results = []
            if(!params || !params.contract) {
                this.showAlert(this.$t('contract_diary.invalid_contract'))
                return undefined
            }
            let mappedParams = {
                contract: params.contract ? params.contract.id : null,
                from: params.startDate ? this.getDateIsoString(new Date(params.startDate)) : null,
                to: params.endDate ? this.getDateIsoString(new Date(params.endDate)) : null,
            }
            this.lastSearchedParams = params
            this.loading = true
            this.restFetchParams(this.contractDiaryUrl, mappedParams, this.handleResponse)

        },
        handleResponse: function (response) {
            if (response && response.data) {
                this.results = response.data
            }
            this.loading = false
        },

        submitDiary(diaryData) {
            if (diaryData) {
                this.loading = true
                const params = {
                    contract: this.contract.id,
                    data: diaryData
                }
                this.restAdd(this.extWorkDiaryUrl, params, this.handleReportOk, this.handleReportFail)
            }
        },
        handleReportOk() {
            this.loading = false
            this.showAlert(this.$t('contracts.external.report_success'), 'success')
            this.equipmentTypes = []
            this.roads = []
        },
        handleReportFail() {
            this.loading = false
            this.showAlert(this.$t('contracts.external.report_failed'))
        },

        linkTabClass(index) {
            if (this.currentTabIndex === index) {
                return ['tab-title', 'tab-title-active']
            } else {
                return ['tab-title']
            }
        }

    }
}
</script>
